
<div class="d-block d-lg-none">
	<ng-container *ngTemplateOutlet="mobileView"></ng-container>
</div>
<div class="d-none d-lg-block">
	<ng-container *ngTemplateOutlet="desktopView"></ng-container>
</div>

<!-- Mobile View Template -->
<ng-template #mobileView>
	<section class="section mobile">
		<div class="mi-gestion"></div>
		<div class="content" *ngIf="{ ultimaFichada: ultimaFichada$ | async, ticketsPendientes: ticketsPendientes$ | async } as data">
			<div class="data-container" *ngIf="!data.ultimaFichada || !isEmptyBundle( data.ultimaFichada ) || !data.ticketsPendientes || !isEmptyBundle( data.ticketsPendientes )"
					[ngClass]="( !data.ultimaFichada || !isEmptyBundle( data.ultimaFichada ) ) && ( !data.ticketsPendientes || !isEmptyBundle( data.ticketsPendientes ) )? 'complete-data': 'single-data'">
				<!-- Última Fichada -->
				<ng-container *ngIf="data.ultimaFichada; else loadingMobile">
					<ng-container *ngIf="!isEmptyBundle( data.ultimaFichada )">
						<div class="data">
							<div class="self-service__fichada-icon--mobile"></div>
							<div>Última fichada</div>
							<div class="important">{{ getTimeAsString( data.ultimaFichada.bundle[0] ) }} hs</div>
							<div>{{ getDateAsString( data.ultimaFichada.bundle[0] ) }}</div>
						</div>
					</ng-container>
				</ng-container>
				<!-- Tickets Pendientes -->
				<ng-container *ngIf="data.ticketsPendientes; else loadingMobile">
					<ng-container *ngIf="!isEmptyBundle( data.ticketsPendientes )">
						<div class="data">
							<div class="self-service__tickets-icon--mobile"></div>
							<div>Tickets pendientes</div>
							<div class="important">{{ data.ticketsPendientes.bundle[0].pendiente }}</div>
						</div>
					</ng-container>
				</ng-container>
			</div>

			<!-- Link de ingreso a Mi-Gestión -->
			<ng-container *ngIf="( miGestionAplicacionPerfil$ | async ) as perfil">
				<div class="links info-link" [managedLink]="STORED_LINK" [queryParams]="{ ida: MI_GESTION, idp: perfil.nombre }" gtagEvent="ver-mi-gestion-rh" gtagCategory="mi-gestion-rh-widget">
					<div>Ingresar a mi gestión RH</div>
					<div class="chevron"></div>
				</div>
			</ng-container>
			<!-- Link de preguntas frecuentes -->
			<!-- <div class="links info-link" [managedLink]="recursosHumanosFAQ" gtagEvent="ver-preguntas-frecuentes" gtagCategory="mi-gestion-rh-widget">
				<div>Preguntas frecuentes</div>
				<div class="chevron"></div>
			</div> -->
		</div>
	</section>
</ng-template>

<!-- Desktop View Template -->
<ng-template #desktopView>
	<div class="info-header">
		<div class="info-header__title"></div>
		<div class="info-header__util">
			<ng-container *ngIf="recursosHumanosReady$ | async; else loadingDesktop">
				<div class="refresh__icon" (click)="onRefreshRecursosHumanos()" gtagEvent="recargar" gtagCategory="mi-gestion-rh-widget"></div>
			</ng-container>
		</div>
	</div>

	<div class="info-content-container" placement="left" [ngbTooltip]="( showTooltip$ | async )? tipContent: ''">

		<!-- Última fichada -->
		<ng-container *ngIf="ultimaFichada$ | async as ultimaFichada">
			<ng-container *ngIf="!isEmptyBundle( ultimaFichada )">
				<div class="info-content">
					<div class="info-content__data-icon">
						<div class="self-service__fichada-icon"></div>
					</div>
					<div class="info-content__data">
						<div class="self-service__data-title">Última fichada</div>
						<ng-container [ngTemplateOutlet]="ultimaFichadaContent" [ngTemplateOutletContext]="{ fecha: getTimeAsString( ultimaFichada.bundle[0] ), desc:  getDateAsString( ultimaFichada.bundle[0] ) }"></ng-container>
					</div>
				</div>
			</ng-container>
		</ng-container>

		<!-- Tickets pendientes -->
		<ng-container *ngIf="ticketsPendientes$ | async as ticketsPendientes">
			<ng-container *ngIf="!isEmptyBundle( ticketsPendientes )">
				<div class="info-content">
					<div class="info-content__data-icon">
						<div class="self-service__tickets-icon"></div>
					</div>
					<div class="info-content__data">
						<div class="self-service__data-title">Tickets pendientes</div>
							<ng-container [ngTemplateOutlet]="tickestPendientesContent" [ngTemplateOutletContext]="{ pendiente: ticketsPendientes.bundle[0].pendiente }"></ng-container>
					</div>
				</div>
			</ng-container>
		</ng-container>

	</div>

	<div>
		<!-- Link de ingreso a Mi-Gestión -->
		<ng-container *ngIf="( miGestionAplicacionPerfil$ | async ) as perfil">
			<div class="info-link" [managedLink]="STORED_LINK" [queryParams]="{ ida: MI_GESTION, idp: perfil.nombre }" gtagEvent="ver-mi-gestion-rh" gtagCategory="mi-gestion-rh-widget">Ingresar a Mi Gestión RH</div>
		</ng-container>
		<!-- Link de preguntas frecuentes -->
		<!-- <div class="info-link" [managedLink]="recursosHumanosFAQ" gtagEvent="ver-preguntas-frecuentes" gtagCategory="mi-gestion-rh-widget">Preguntas Frecuentes</div> -->
	</div>
</ng-template>

<!-- Ultima Fichada Content Template -->
<ng-template #ultimaFichadaContent let-fecha="fecha" let-desc="desc">
	<div class="self-service__data">{{ fecha }} hs</div>
	<div class="self-service__data-desc">{{ desc }}</div>
</ng-template>

<!-- Tickets Pendientes Content Template -->
<ng-template #tickestPendientesContent let-pendiente="pendiente" let-desc="desc">
	<div class="self-service__data">{{ pendiente }}</div>
	<ng-container *ngIf="desc">
		<div class="self-service__data-desc">{{ desc }}</div>
	</ng-container>
</ng-template>

<!-- Loading Recursos Humanos Desktop Template -->
<ng-template #loadingDesktop>
	<div class="loading__icon spinner-border text-info"></div>
</ng-template>

<!-- Loading Recursos Humanos Mobile Template -->
<ng-template #loadingMobile>
	<loading></loading>
</ng-template>

<!-- Tip Content Template -->
<ng-template #tipContent>
	<div *ngIf="{ ultimaFichada: showUltimaFichada$ | async, ticketsPendientes: showTicketsPendientes$ | async } as show" class="self-service__tooltip">
		<p>
			<ng-container *ngIf="show.ultimaFichada && show.ticketsPendientes">Los datos de fichada y números de tickets pueden </ng-container>
			<ng-container *ngIf="show.ultimaFichada && !show.ticketsPendientes">La fichada puede </ng-container>
			<ng-container *ngIf="!show.ultimaFichada && show.ticketsPendientes">Los números de tickets pueden </ng-container>
			variar según contratación y sede institucional de los empleados.
		</p>

		<p>La información es actualizada por Recursos Humanos durante el transcurso del día.</p>
	</div>
</ng-template>
